<template>
    <div class="resource-center-card" :id="id">
        <div class="resource-center-card-title">
            {{ title }}
        </div>
        <div class="resource-center-card-content">
            <div class="card-cell" v-for="(item, index) in content" :key="index" @click="goDetail(item.id)">
                <img :src="item.picture" alt="" />
                <div class="card-cell-title">
                    <p>{{ item.title }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        content: {
            type: Array,
            default: () => [
            ]
        }
    },
    methods: {
        goDetail(id) {
            if (id) {
                this.$router.push({
                    name: "topicPage",
                    query: { topicId: id, isGame: "true" },
                });
            } else {
                console.warn('no id provided')
            }
        }
    }
}
</script>

<style lang='scss' scoped>
.resource-center-card {
    &-title {
        font-size: .28;
        margin-bottom: .2rem;
    }

    &-content {
        padding: .1rem;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0 .3rem;

        .card-cell {
            user-select: none;
            cursor: pointer;
            width: 100%;
            margin-bottom: .3rem;

            img {
                width: 100%;
                height: 1.8rem;
                object-fit: cover;
            }

            &-title {
                padding: 0 .1rem;
                font-size: .22rem;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-word;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }

        .card-cell:last-child {
            margin-right: auto;
        }
    }
}

.ipad {
    .resource-center-card {
        &-content {
            grid-template-columns: repeat(5, 1fr);

            .card-cell {
                img {
                    width: 2rem;
                    height: 1.2rem;
                }
            }
        }
    }
}
</style>